export enum unit_type {
  Pcs = 'PCS',
  M = 'M',
  Qm = 'QM',
  // Start Userdefined content - don't change anything above
  // End Userdefined content - don't change anything below
}
